module.exports = __webpack_public_path__ + "static/media/Global Lounge Logo.0d3cdc5b.png";